import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import DownloadIcon from '@material-ui/icons/CloudDownload';
import { chain, filter, forEach, includes, map, orderBy, some } from "lodash";
import withStyles from "@material-ui/core/styles/withStyles";
import * as Animated from "react-select/lib/animated";

import Assignment from "@material-ui/icons/Assignment";
import Button from "components/CustomButtons/Button.jsx";
import CustomPagination from "components/EnergyCompany/Pagination/custom-pagination";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Table from "components/Table/Table.jsx";
import { localeString, scrollToElement } from "services/utils";

const empresasFiltradasStyle = theme => ({
  button: {
    margin: "10px 0 0",
  },
  icon: {
    margin: "0 5px 0 0 !important",
  },
});

class EmpresasFiltradas extends Component {
  constructor(props) {
    super(props);

    const columns =
      chain(props.relatorio.colunas)
      .map((coluna, index) => ({ ...coluna, order: index + 1 }))
      .filter(({ id }) => id !== props.colunaFixa.key)
      .value();

    this.state = {
      columns,
      filtros: filter(columns, column => includes(props.relatorio.colunasIniciais, column.id)),
    };
  }

  componentDidMount() {
    scrollToElement(this.table);
  }

  getData() {
    const { colunaFixa, itens, relatorio } = this.props;
    const getLink = (item, index) => {
      return (
        <a
          key={index}
          onClick={() => this.props.searchEmpresa(item)}
          style={{ cursor: "pointer" }}
        >
          {item[colunaFixa.key]}
        </a>
      );
    };

    return map(itens, (item, index) => filter([
      relatorio.indiceInicio + index,
      getLink(item, index),
      ...map(this.state.columns, column => this.shouldShowColumn(column.id) && localeString(item[column.id])),
    ], value => value !== false));
  };

  getHeaders() {
    const { colunaFixa } = this.props;
    let headers = ['#', colunaFixa.label];

    forEach(this.state.columns, column => {
      if (this.shouldShowColumn(column.id)) {
        headers.push(column.nome);
      }
    });
    return headers;
  }

  shouldShowColumn(columnId) {
    return some(this.state.filtros, filtro => filtro.id === columnId);
  }

  handleFiltroChange = value => {
    const orderedValues = orderBy(value, ['order']);
    this.setState({ filtros: orderedValues });
  }

  render () {
    const { classes, downloadCSV, itens, relatorio, requestNextPage } = this.props;
    const { columns, filtros } = this.state;

    return (
      <div ref={node => this.table = node}>
        <GridContainer>
          <GridItem xs={12}>
            <ECCard
              actions={
                <Button
                  className={classes.button}
                  color="info"
                  onClick={downloadCSV}
                  size="sm"
                >
                  <DownloadIcon className={classes.icon} />
                  Download CSV
                </Button>
              }
              content={
                <div>
                  <Select
                    components={Animated}
                    getOptionLabel={option => option.nome}
                    getOptionValue={option => option.id}
                    isMulti
                    noOptionsMessage={() => 'Todos os filtros estão selecionados'}
                    onChange={this.handleFiltroChange}
                    options={columns}
                    placeholder="Colunas"
                    value={filtros}
                  />
                  <Table
                    tableData={this.getData()}
                    tableHead={this.getHeaders()}
                    tableHeaderColor="primary"
                  />

                  <CustomPagination
                    items={itens}
                    onChangePage={requestNextPage}
                    totalItens={relatorio.totalItens}
                  />
                </div>
              }
              icon={<Assignment />}
              title={`Empresas Filtradas (${relatorio.totalItens})`}
            />
          </GridItem>
        </GridContainer>
      </div>
    );
  };
};

EmpresasFiltradas.propTypes = {
  classes: PropTypes.object.isRequired,
  colunaFixa: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  downloadCSV: PropTypes.func.isRequired,
  itens: PropTypes.array.isRequired,
  relatorio: PropTypes.shape({
    colunas: PropTypes.arrayOf(PropTypes.object).isRequired,
    colunasIniciais: PropTypes.arrayOf(PropTypes.string).isRequired,
    indiceInicio: PropTypes.number,
    totalItens: PropTypes.number,
  }),
  requestNextPage: PropTypes.func.isRequired,
  searchEmpresa: PropTypes.func.isRequired,
};

export default withStyles(empresasFiltradasStyle)(EmpresasFiltradas);



// WEBPACK FOOTER //
// ./src/views/Dashboard/relatorio-partials/EmpresasFiltradas.jsx